import { Log, UserManager } from 'oidc-client-ts';
import { config } from '../../config.ts';

export const handleLoginRedirect = () => {
    // biome-ignore lint/complexity/useOptionalChain: suppress out of convenience during migration to biome
    const runsInIframe = window && window.parent && window.parent !== window;

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        // This will propagate the received information provided via
        // query parameters to the parent frame
        new UserManager({
            authority: `${config.login.authority}`,
            client_id: `${config.login.clientId}`,
            redirect_uri: `${config.login.redirectUri}`,
            filterProtocolClaims: false,
        }).signinSilentCallback();
    } else {
        window.location.replace(`${window.location.origin}#/?${window.location.hash.replace('#', '')}`);
    }
};
